import { accessRole } from "../../../../helpers/access_role";
import Shimmer from "react-shimmer-effect";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Select from "../../../../helpers/ui/CustomSelect";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";
import IndexBloc from "../Index/Blocs/IndexBloc";

// var reformatOptions = function (raw) {
//   return raw.map(function (data) {
//     var newObj = {};
//     newObj["label"] = data.current_position_name_new;
//     newObj["value"] = data.special_allowance_summary_rev_uuid;

//     return newObj;
//   });
// };

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];
    newObj["model"] = data;

    return newObj;
  });
};

// var reformatOptions = function (datas) {
//   console.log(datas);
//   return datas.map(function (item) {
//     debugger;
//     var newObj = {};
//     newObj["label"] = item.current_position_name_new;
//     newObj["value"] = item.special_allowance_summary_rev_uuid;
//     newObj["model"] = item;
//     return newObj;
//   });
// };

class IndexView extends Component {
  queryParams = new URLSearchParams(window.location.search);
  createBloc = new CreateBloc();
  indexBloc = new IndexBloc();
  timer;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      gradeListOption: null,
      positiontype: [
        { label: "Definitif", value: 1 },
        { label: "PLT", value: 2 },
      ],
      positionOption: null,
      selectedGradeBefore: null,
    };
  }

  submitData = async () => {
    await this.createBloc.fetchCreate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        employee_uuid: this.queryParams.get("employee_uuid"),
        period_uuid: this.queryParams.get("period_uuid"),
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
    this.createBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;
        case apiResponse.COMPLETED:
          this.setState({
            detail: result.data?.response?.result,
            loadingDetail: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchDetail({
      revision_uuid: this.queryParams.get("revision_uuid"),
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.detailChannel?.unsubscribe();
    this.createBloc.gradeListChannel?.unsubscribe();
    this.createBloc.positionListChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody style={{ height: "500px" }}>
                  <div className="float-end">
                    <Link to={`/kepegawaian/mapping_tunjangan_khusus.html`}>
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Revisi Presensi Pegawai</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Nama Pegawai <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_rev_employee_full_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_rev_employee_full_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        NIP <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_rev_employee_nip !== ""
                              ? this.state.detail
                                  .special_allowance_summary_rev_employee_nip
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Unit Kerja <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_rev_employee_current_work_unit_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_rev_employee_current_work_unit_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Status Pegawai <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_rev_employee_categories_name_full !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_rev_employee_categories_name_full
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Jabatan Definitif <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_rev_employee_current_position_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_rev_employee_current_position_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Presensi Sebelum <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_rev_presensi_before !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_rev_presensi_before
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="special_allowance_summary_rev_presensi"
                        className="col-md-3 col-form-label"
                      >
                        Presensi Revisi <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="special_allowance_summary_rev_presensi"
                          // value={
                          //   this.state.detail
                          //     .special_allowance_summary_rev_presensi
                          // }
                          placeholder="Presensi Revisi..."
                          type="number"
                          errorMessage="Masukkan Presensi Revisi"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="special_allowance_summary_rev_presensi"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/mapping_tunjangan_khusus.html?" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
